module.exports = new __parcel__URL__("line-chart-staging.0cc32c4b.svg").toString();